export interface Quality {
  word: string;
  reflection: string;
  practices: string[];
}

export const qualities: Quality[] = [
  {
    word: 'devotion',
    reflection: 'today, you notice the small moments where giving feels like a return to yourself',
    practices: [
      'perform one act of care no one will see',
      'say one thing aloud that you are devoted to',
      "let one person's small need become your day's small task",
    ],
  },
  {
    word: 'mischief',
    reflection: 'today, the playfulness wakes up. you let it.',
    practices: [
      'do one thing slightly out of character',
      'make someone laugh today',
      'follow a small, harmless impulse',
    ],
  },
  {
    word: 'stillness',
    reflection: 'today, the practice is to stop moving. literally and otherwise.',
    practices: [
      'five minutes of doing nothing, deliberately',
      'let one thing be unfinished today',
      'wait one beat longer than feels comfortable before responding',
    ],
  },
  {
    word: 'patience',
    reflection: 'today, you let the time it takes be the time it takes',
    practices: [
      'choose the slower of two options',
      "wait until you're asked instead of offering",
      'finish one thing without rushing the last 10%',
    ],
  },
  {
    word: 'attention',
    reflection: 'today, what you give attention to grows. choose carefully.',
    practices: [
      'eat one meal without looking at a screen',
      'really look at one person while they speak',
      'put your phone in another room for one hour',
    ],
  },
  {
    word: 'softness',
    reflection: 'today, the edges round. you do not push.',
    practices: [
      'lower your voice by half today',
      'choose a soft fabric and notice it',
      'let a small disagreement go',
    ],
  },
  {
    word: 'precision',
    reflection: 'today, the small details are the practice',
    practices: [
      'do one task to the best of your current ability',
      'use the exact word, not the close one',
      'arrive five minutes early',
    ],
  },
  {
    word: 'discipline',
    reflection: 'today, you honor the thing you said you would do',
    practices: [
      'complete one habit you have been skipping',
      'say no to the easy detour',
      "finish before you reward yourself",
    ],
  },
  {
    word: 'delight',
    reflection: 'today, you let yourself be charmed',
    practices: [
      'notice one beautiful thing per hour',
      'eat something purely for pleasure',
      'tell someone what made you smile',
    ],
  },
  {
    word: 'service',
    reflection: 'today, you make someone\'s life slightly smaller and more comfortable',
    practices: [
      'do one chore for someone else without being asked',
      'remember a small preference and act on it',
      'leave a space better than you found it',
    ],
  },
  {
    word: 'curiosity',
    reflection: 'today, "i wonder" is the better question than "i know"',
    practices: [
      'ask one question you do not already know the answer to',
      'try one thing you have been curious about, even briefly',
      'replace one judgment with a question',
    ],
  },
  {
    word: 'gratitude',
    reflection: 'today, you name what you would miss if it were gone',
    practices: [
      'write three specific things you are grateful for',
      'thank one person for something they would not expect',
      'pause before a meal',
    ],
  },
  {
    word: 'presence',
    reflection: 'today, you arrive where you already are',
    practices: [
      'feel your feet on the floor three times',
      'finish what you are doing before starting the next',
      'breathe with someone in silence for a minute',
    ],
  },
  {
    word: 'generosity',
    reflection: 'today, you give more than is asked. quietly.',
    practices: [
      'leave a tip larger than you usually would',
      'share something you would normally keep',
      'offer your time before being asked for it',
    ],
  },
  {
    word: 'humility',
    reflection: 'today, you do not need to be right',
    practices: [
      'say "i was wrong" once, plainly',
      'let someone else have the last word',
      'ask for help on something small',
    ],
  },
  {
    word: 'holding',
    reflection: 'today, you hold the space without filling it',
    practices: [
      'let someone speak without solving',
      'sit with a feeling rather than fixing it',
      'witness instead of advising',
    ],
  },
  {
    word: 'receiving',
    reflection: 'today, you let in what is offered',
    practices: [
      'accept a compliment without deflecting',
      'let someone do something for you without protesting',
      'rest when you are tired',
    ],
  },
  {
    word: 'waiting',
    reflection: 'today, you let things ripen',
    practices: [
      'pause before responding to a message',
      'sit with a decision overnight',
      'finish a sentence in your head before you speak',
    ],
  },
  {
    word: 'noticing',
    reflection: 'today, what was always there becomes visible',
    practices: [
      'walk a familiar route at half speed',
      'count five things in your view you have not noticed before',
      'name three sounds in this moment',
    ],
  },
  {
    word: 'listening',
    reflection: 'today, you hear what is being said and what is not',
    practices: [
      "let someone finish a thought without interrupting",
      'ask one follow-up question instead of switching topics',
      'listen for what is underneath the words',
    ],
  },
  {
    word: 'openness',
    reflection: 'today, the door is unlatched',
    practices: [
      'say yes to one small invitation',
      'consider a perspective you usually dismiss',
      'take a different route to a familiar place',
    ],
  },
  {
    word: 'trust',
    reflection: 'today, you proceed without certainty',
    practices: [
      'take one step before you can see the next',
      'let someone do something their way',
      'release control of a small outcome',
    ],
  },
  {
    word: 'tenderness',
    reflection: 'today, you are gentle with the soft places',
    practices: [
      'speak to yourself the way you would speak to someone you love',
      'touch one thing with deliberate care',
      'be patient with someone who is having a hard day',
    ],
  },
  {
    word: 'surrender',
    reflection: 'today, you stop pushing against what is already so',
    practices: [
      'release one thing you have been gripping',
      'let the day unfold without an agenda',
      'feel a feeling completely before moving on',
    ],
  },
  {
    word: 'courage',
    reflection: 'today, you do the small brave thing',
    practices: [
      'have the conversation you have been avoiding',
      'say what you actually want',
      'try something you might be bad at',
    ],
  },
  {
    word: 'honesty',
    reflection: 'today, what you say matches what is true',
    practices: [
      'tell one truth you have been softening',
      'admit when you do not know',
      'name what you actually feel',
    ],
  },
  {
    word: 'clarity',
    reflection: 'today, you let the fog burn off',
    practices: [
      'write what you are confused about until it untangles',
      'ask the question that gets you the answer you need',
      'state your intent plainly',
    ],
  },
  {
    word: 'restraint',
    reflection: 'today, you have the urge and you do not act on it',
    practices: [
      'pause before sending the message',
      'consider whether the second helping is wanted or habitual',
      'let a thought pass without acting',
    ],
  },
  {
    word: 'grace',
    reflection: 'today, you move through difficulty without making it harder',
    practices: [
      'let a small slight pass uncorrected',
      'thank someone for an inconvenience they caused',
      'forgive yourself for a small failure quickly',
    ],
  },
  {
    word: 'boldness',
    reflection: 'today, you take up the space you have been allotted',
    practices: [
      'ask for what you want directly',
      'wear something you have been saving',
      'make the first move',
    ],
  },
  {
    word: 'care',
    reflection: 'today, the quality of attention itself is the gift',
    practices: [
      'do one task slowly and well',
      'tend something living',
      'follow up on something that fell through',
    ],
  },
  {
    word: 'quietude',
    reflection: 'today, you make less noise than you usually would',
    practices: [
      'spend an hour without speaking',
      'choose silence when small talk is offered',
      'turn off the music for a while',
    ],
  },
  {
    word: 'wonder',
    reflection: 'today, you let things astonish you',
    practices: [
      'look up at the sky long enough to forget what you were doing',
      'read about something far outside your usual',
      'let a question stay open',
    ],
  },
  {
    word: 'yielding',
    reflection: 'today, you bend so you do not break',
    practices: [
      'let someone else choose',
      'change your mind based on new information',
      'soften a position that was costing more than it earned',
    ],
  },
  {
    word: 'willingness',
    reflection: 'today, the answer is yes before you know what is asked',
    practices: [
      'volunteer for the small annoying task',
      'try a new thing for ten minutes',
      'agree to be a little uncomfortable',
    ],
  },
  {
    word: 'steadiness',
    reflection: 'today, you are the calm one in the room',
    practices: [
      'speak more slowly than feels natural',
      'do not match someone else\'s anxiety',
      'finish what you started before the panic',
    ],
  },
  {
    word: 'play',
    reflection: 'today, the work is also a game',
    practices: [
      'do one chore as if it were performance',
      'make up a small ritual for an ordinary moment',
      'follow a tangent without judgment',
    ],
  },
  {
    word: 'focus',
    reflection: 'today, one thing at a time gets your whole self',
    practices: [
      'close every tab but the one you are using',
      'finish one thing before starting another',
      'put a timer on and stay with it until it rings',
    ],
  },
  {
    word: 'acceptance',
    reflection: 'today, this is what is, and you let it be that',
    practices: [
      'say "this is happening" before reacting',
      'release a wish that is costing you the present',
      'let someone be who they are right now',
    ],
  },
  {
    word: 'rest',
    reflection: 'today, you let yourself stop. it is enough.',
    practices: [
      'go to bed earlier than you planned',
      'skip the optional commitment',
      'do nothing for fifteen minutes without guilt',
    ],
  },
];
